import { useI18n } from '@cascade/react/i18n';
import { Button, Text } from '@cascade/ui-library';
import classes from './EmailNotFound.module.scss';
import type { TEmailNotFoundProps } from './EmailNotFound.types.ts';
import { SupportContact } from '#components/support-contact/index.ts';

export const EmailNotFound = ({ onBack }: TEmailNotFoundProps) => {
  const { translate } = useI18n();

  return (
    <div className={classes['email-not-found']}>
      <div className={classes.paragraphs}>
        <Text
          type='body-2'
          content={translate('signIn.emailNotFound.notFound')}
        />
        <Text
          type='body-2'
          content={translate('signIn.emailNotFound.contactEmployer')}
        />
        <Text
          type='body-2'
          content={translate('signIn.emailNotFound.contactSupport')}
        />
      </div>
      <SupportContact />
      <Button
        variant='secondary'
        label={translate('signIn.emailNotFound.back')}
        onClick={onBack}
      />
    </div>
  );
};
